import { useContext } from 'react';
import { RootStore, StoreContext } from '../store';

export const useStore = ():RootStore => useContext(StoreContext);
